import React from 'react';

import { SkeletonItem } from '@atlaskit/menu';

export function DefaultFallback(): React.JSX.Element {
	return (
		<>
			<SkeletonItem />
			<SkeletonItem />
			<SkeletonItem />
			<SkeletonItem />
		</>
	);
}
